import { BUSINESS_MANAGER_URL } from "../../../shared/constants";

export const makeBusinessManagerUrl = (organizationId: string, lensFolderId: string): string =>
    `${BUSINESS_MANAGER_URL}/${organizationId}/lens-folders/${lensFolderId}/lenses`;
